import CreateAffiliateCampaignPage from "./create-affiliate-campaign.page";

export default CreateAffiliateCampaignPage;
